/**
 * Conversion constant: Wei per Gwei (10^9)
 *
 * @see https://voltaire.tevm.sh/primitives/denomination for Denomination documentation
 * @since 0.0.0
 */
export const WEI_PER_GWEI = 1_000_000_000n;

/**
 * Conversion constant: Wei per Ether (10^18)
 *
 * @see https://voltaire.tevm.sh/primitives/denomination for Denomination documentation
 * @since 0.0.0
 */
export const WEI_PER_ETHER = 1_000_000_000_000_000_000n;
